import React, { useState } from "react";
import HTMLEllipsis from "react-lines-ellipsis/lib/html";

const DisplayText = (props) => {
  const [isExpand, setExpand] = useState(false);
  let htmlObj = null;
  let text = props.text;
  if (props.mode == "label") {
    htmlObj = props.text;
  } else if (props.mode == "ellipsis") {
    htmlObj = (
      <>
        {isExpand ? (
          <div
            className="display-text"
            onClick={(e) => {
              e.preventDefault();
              setExpand(!isExpand);
            }}
          >
            <div dangerouslySetInnerHTML={{ __html: props.text }} />
            <span className="badge badge-info ellipsis-btn">Show Less</span>
          </div>
        ) : (
          <div
            className="display-text"
            onClick={(e) => {
              e.preventDefault();
              setExpand(!isExpand);
            }}
          >
            <HTMLEllipsis
              unsafeHTML={props.text}
              maxLine={props.maxLine == undefined ? "5" : props.maxLine}
              ellipsisHTML={`...<span class='badge badge-info ellipsis-btn'>Show All</span>`}
              basedOn="words"
            />
          </div>
        )}
      </>
    );
  } else {
    htmlObj = <div className="display-text" dangerouslySetInnerHTML={{ __html: props.text }} />;
  }
  return props.isRequired ? (
    <div className="display-text" style={{ fontSize: "14px" }}>
      <span
        style={{
          float: "left",
          display: "inline-block",
          color: "#ff4d4f",
          fontFamily: "SimSun, sans-serif",
          lineHeight: 1,
        }}
      >
        *
      </span>
      <span
        style={{
          float: "left",
          display: "inline-block",
          paddingLeft: "5px",
        }}
      >
        {" "}
        {htmlObj}
      </span>
    </div>
  ) : (
    <>{htmlObj}</>
  );
};
export default DisplayText;
